const jaTranslations = {
  home: 'ホーム',
  collections: '総合',
  developers: '開発者',
  organization: '組織',
  profile: 'プロファイル',
  logout: 'ログアウト',
  search: '検索',

  allCaughtUp: '全て最新状態です',
  noNotif: '新たな通知はありません',

  // Login and register screens
  newUser: '新規ユーザーは',
  createAccount: 'アカウントを作成',
  alreadyAccount: '既にアカウントをお持ちの方は',
  register: '登録',
  email: 'メールアドレス',
  password: 'パスワード',
  login: 'ログイン',
  loginAccount: 'アカウントへログイン',
  listOfProducts: '商品リスト',
  viewDeveloper: '開発者情報を見る',
  firstName: '名',
  lastName: '姓',
  confirmPassword: 'パスワードを認証する',

  // Sidebar
  products: '商品',
  categories: 'カテゴリー',
  analytics: '分析',
  createCategory: 'カテゴリーを追加',

  // Products list page
  view: '閲覧',
  edit: '編集',
  delete: '削除',
  publishedOn: '公開日（年/月/日）',

  // Error screens
  errUserdet: 'ユーザーの詳細を取得中にエラーが発生しました',
  errNetworkLogin: 'これはネットワークの問題であるか、間違ってログインしている可能性があります',

  sort: 'ソート',
  show: '表示',
  recentModified: '最近変更',
  all: '全て',
  enabled: 'イネーブル',
  disabled: 'ディスエーブル',
  enable: 'イネーブル',
  disable: 'ディスエーブル',
  createNewProduct: '新規商品作成',
  productsSelected: 'つの商品を選択',
  selectAll: '全ての商品を選択',
  cancel: 'キャンセル',
  bulkActions: '一括操作',

  copyLink: 'リンクをコピー',
  unpublish: '非公開',
  annotation: '注釈',
  details: '詳細',
  name: '名前',
  description: '商品説明',
  annotations: '注釈',
  addAnnotation: '注釈を追加',
  clickAddAnnotation: '注釈を追加する部分をクリック',
  annoName: '注釈の名前',
  content: '内容',
  dailyViewsPastWeek: '先週各日のレビュー',
  preview: 'プレビュー',
  backProducts: '商品一覧に戻る',
  backCategories: 'カテゴリー覧に戻る',
  viewsCategory: 'カテゴリー別商品閲覧',
  mostViewProducts: '最も閲覧された商品',
  confirm: '確認',
  noDescription: '記述なし',
  noAnnotations: '注釈なし',

  productOptions: '商品オプション',
  noProductOptions: 'オプションなし',
  variant: '色の選択',
  color: '色',
  unnamedAnnotation: '名前なし説明記述',

  users: 'ユーザー',
  billing: '請求する',
  invoices: '請求書',
  settings: '設定',
  addUser: 'ユーザーを追加する',
  admin: '管理者',
  manager: 'マネジャー',
  viewer: 'ビューアー',
  editor: '編集者',
  role: '役割',
  currentUsage: '現在の使用状況',
  paymentInformation: '支払情報',
  noPaymentAdded: 'お支払い方法が追加されていません',
  noPastInvoices: '過去の請求書はありません',
  notifyNewInvoices: '新しい請求書についてお知らせします',
  companyName: '会社名',
  contactEmail: '連絡先メールアドレス',

  actions: 'アクション',
  editProfile: 'プロファイルの編集',
  updatePassword: 'パスワードの更新',
  deactivateAcc: 'アカウントを無効化',
  currentPass: '現在のパスワード',
  newPass: '新しいパスワード',
  confirmNewPass: '新しいパスワードを確認',
  update: 'アップデート',
  passnoMatch: 'パスワードが一致しません。 再度確認してください',

  overview: '概要',
  productViews: '製品ビュー',
  newVis: '新規訪問者',
  mostViewedProd: '最も閲覧数の多い製品',

  pageView: 'ページビュー',
  devices: 'デバイス',
  os: 'オペレーティング·システム',
  desktop: 'デスクトップ',
  mobile: 'モバイル',
  tablet: 'タブレット',
  utra: 'ユーザー追跡',
  location: 'ロケーション',
  unknown: 'わからない',
  direct: '直接トラフィック',
  none: 'なし',
  referral: 'レフェラル',
  Mac: 'マック',
  iOS: 'iOS',
  Android: 'アンドロイド',
  other: '他の',
  Windows: 'ウィンドウズ',
  source: 'ソース',
  medium: '媒体',
  views: 'ビュー',

  'Asia/Calcutta': 'インド',
  'Asia/Tokyo': '日本',
  PST8PDT: '米国西部およびカナダ',
  'Asia/Riyadh': 'サウジアラビア',
  'America/Los_Angeles': '米国西部',

  dev: {
    dg: '開発者ガイド',
    gs: '入門',
    em: 'プレビューの埋め込みは簡単です。 ページのビューアを表示したい場所に、以下の iframe コードを追加するだけです。',
    df: "'***product_id*** を製品の ID に置き換えることを忘れないでください。'",
    af: 'いくつかのメモ:',
    sr: 'src: ',
    rp: '***product_id*** を製品の ID に置き換えることを忘れないでください。',
    sz: 'サイズ: ',
    if: '他の要素の場合と同様に、CSS を使用して iframe のサイズを調整できます。 3D ビューアは、常に iframe のコンテンツに合わせてサイズ変更されます。',
    at: `"allowfullscreen" 属性: `,
    ab: 'この属性がない場合、ビューアはフルスクリーン ボタンを表示しません。 存在する場合、ブラウザがサポートしている場合にのみボタンを表示します。 「no_fullscreen」url オプションを使用して、ボタンを iframe の外側に表示するかどうかを引き続き制御できます',
    pg: '遊び場',

    ls: 'あなたの生活をよりシンプルにするために、私たちは遊び場のインターフェースを作成しました。 オプションを調整して、対応するコードを埋め込んだリアルタイム プレビューを表示します。',
    de: 'オプションの詳細については、次のセクションで説明します。',

    co: '上記のオプションのコード:',
    cp: 'クリップボードにコピー',

    cop: '構成オプション',
    vb: '3D ビューアの動作は、url パラメータで制御できます。 すべてのオプションのデフォルトとして、最も広く設定されている値を選択します。 追加のカスタマイズのオプションをご希望の場合は、お問い合わせください。調査いたします。',
    lo: '利用可能なすべてのオプションのリスト:',

    sp: 'サポート',
    wt: '私たちは、技術をできるだけシンプルに保つために最善を尽くしています。',
    hi: '埋め込みの統合に関するサポートが必要な場合、改善のための提案がある場合、またはバグを報告したい場合は、hello@euclidxr.com までお気軽にお問い合わせください。',

    yes: 'はい',
    no: '番号',

    pi: '製品番号',
    bc: '背景色',
    th: 'テーマ',
    da: '暗い',
    l: 'ライト',
    st: '開始時のロード',
    po: 'ポスターを表示',
    ro: '自動回転',
    ar: 'AR が利用可能',
    hp: 'プロンプトを非表示',
    ai: 'インタラクションを許可',
    fl: 'フルスクリーンを許可',
    ho: '非表示オプション',
    la: '言語',

    op: 'オプション',
    dl: 'デフォルト',
    dt: '詳細',
    opb: 'インターフェイスの背景色。 現在、これは 16 進値 (#RRGGBB) のみをサポートしています。 これはテキストの色を変更しないことに注意してください。 したがって、テキストのコントラストが低くて読みにくい場合は、テーマ オプションを変更してみてください。',
    opw: '有効にすると、ユーザーが手動でクリックして 3D モデルをロードできるボタンが表示されます。 複数の 3D モデルを 1 つのページに表示する場合に便利です。',
    opi: '実際のモデル ファイルの読み込み中に 3D モデルの画像を表示するかどうか。',
    ops: `「dark」に設定すると、テキストの色を調整して、暗い背景でのコントラストを向上させます。`,
    opc: 'モデルを 360 度連続回転します。',
    opr: '回転速度 (度/秒)。 自動回転が設定されている場合にのみ機能します。',
    opo: 'このオプションを設定すると、ユーザーはマウス/タッチで 3D ビューアを操作できなくなります。',
    opp: 'ユーザーが 3D モデルをフルスクリーンで表示できないようにします。',
    oph: 'オプション パネルを非表示にします。',
    opv: `AR をサポートしているにもかかわらず、すべてのデバイスの [自分のスペースで表示] ボタンを非表示にします。`,
  },
};

export default jaTranslations;
